<script>
import NoOrders from "./NoOrders";
import Loader from "@/components/_Shared/Loader";

import { vPage } from "v-page";

import dateMixin from "@/mixins/dateMixin.js";
import addressMixin from "@/mixins/addressMixin.js";
import timeMixin from "@/mixins/timeMixin.js";
import numberMixin from "@/mixins/numberMixin.js";
import orderMixin from "@/mixins/orderMixin.js";

import { mapState, mapActions } from "vuex";

export default {
  mixins: [addressMixin, dateMixin, timeMixin, numberMixin, orderMixin],
  components: {
    vPage,
    NoOrders,
    Loader
  },

  computed: {
    ...mapState("orders", ["list", "preloader", "pagination", "sort", "type"])
  },

  methods: {
    ...mapActions("orders", ["listAll", "setCurrentPage", "setSort", "setType"])
  },

  mounted() {
    this.listAll();
  }
};
</script>

<template>
  <section>
    <no-orders v-if="!list.length && !preloader" />

    <loader v-else-if="preloader" />

    <div v-else class="card">
      <div class="row align-center mb-30">
        <div class="title">histórico de limpezas</div>

        <div class="buttons-filters">
          <router-link :to="{name: 'purchase-flow'}" class="btn bg-pink">fazer novo pedido</router-link>
        </div>
      </div>

      <div class="table mb-20">
        <table>
          <thead>
            <tr>
              <th>Profissional</th>
              <th>Data e duração</th>
              <th>Endereço</th>
              <th>Status</th>
              <th>Ação</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="order in list" :key="order.id">
              <td>
                <div class="with-image">
                  <img :src="order.professional.account.profile.profile_picture" />
                  <span
                    class="truncate"
                  >{{order.professional.account.first_name}} {{order.professional.account.last_name}}</span>
                </div>
              </td>
              <td>{{order.schedule_event.starts_at | formatDate('DD/MM [às] H[h]')}} - {{order.schedule_event.duration | secToHours(true)}}</td>
              <td class="truncate">{{order.address | fullAddress}}</td>
              <td>
                <span>{{order.status | getTranslatedName}}</span>
              </td>
              <td class="buttons" nowrap>
                <router-link
                  :to="'pedidos/'+order.id"
                  class="btn btn-small bg-purple-outline float-right"
                >ver mais</router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <v-page
        :page-size-menu="false"
        :info="false"
        :first="false"
        :last="false"
        :total-row="pagination.totalResults"
        :value="pagination.current"
        @page-change="setCurrentPage($event)"
        align="center"
      ></v-page>
    </div>
  </section>
</template>

<style scoped>
.truncate {
  max-width: 190px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderHistory/Desktop.vue